import api from '../../../../helpers/api';
import { CreateStudyPayload, StudyStepPayloads } from './studies.model';

export const getStudiesList = async (
  pageNumber: string,
  studyTitle?: string
) => {
  const response = await api.get(
    `developer/platform/study/study?page=${pageNumber}${
      studyTitle ? `&title=${studyTitle}` : ''
    }`
  );
  return response.data;
};

export const createStudy = async (payload: CreateStudyPayload) => {
  const response = await api.post('/developer/platform/study/study', payload);

  return response;
};

export const deleteStudy = async (study_id: string) => {
  await api.delete(`developer/platform/study/study/${study_id}`);
};

export const postStudyStep = async (
  stepNumber: number,
  study_id: string,
  payload: StudyStepPayloads,
  customHeader?: Record<string, string> | null
) => {
  const response = await api.post(
    'developer/platform/study/step_study',
    payload,
    {
      headers: { study_step: stepNumber, study_id, ...customHeader },
    }
  );
  return response.data;
};

export const patchStudyStep = async (
  stepNumber: number,
  study_id: string,
  payload: any
) => {
  const response = await api.patch(
    'developer/platform/study/step_study',
    payload,
    {
      headers: { study_step: stepNumber, study_id },
    }
  );
  return response.data;
};

export const getStudyById = async (studyId: string) => {
  const { data } = await api.get(`developer/platform/study/study/${studyId}`);

  return data;
};

export const patchStudy = async (
  payload: { name: string; is_public: boolean },
  studyId: string
) => {
  const response = await api.patch(
    `developer/platform/study/study/${studyId}`,
    payload
  );
  return response;
};

export const uploadPDFReport = async (
  studyId: string,
  blob: Blob,
  author: string,
  fileTitle: string
) => {
  const header = {
    'content-type': 'multipart/form-data',
    author: author,
    file_title: fileTitle,
    study_id: studyId,
  };
  const file = new File([blob], fileTitle);
  const formData = new FormData();
  formData.append('file', file, `${fileTitle}.pdf`);

  const response = await api.post(
    `developer/platform/study/documents/${studyId}`,
    formData,
    { headers: header }
  );
  return response;
};

export const getPDFReport = async (studyId: string) => {
  const response = await api.get(
    `developer/platform/study/documents/${studyId}`
  );
  return response;
};
